/*global FB:true*/

import PropTypes from 'prop-types'

import React, { Component } from 'react'
import { connect } from 'react-redux'

import styles from './social.scss'

class FacebookButton extends Component {

	render() {
		const facebookHandler = () => {
			this.props.onSelect()
			FB.ui(this.props.dataObject)
		}

		if (this.props.vendors.facebook) {
			return <a className={styles.icon} onClick={facebookHandler}>
				<svg className={styles.svg} height="50" width="50" viewBox="-5 -5 50 50"> <g className={styles.g}fill="#6A686A"> <path d="M20-2.91C32.632-2.91 42.912 7.365 42.912 20c0 12.632-10.28 22.91-22.912 22.91S-2.913 32.632-2.913 20C-2.913 7.366 7.37-2.91 20-2.91M20-5C6.19-5-5 6.19-5 20c0 13.807 11.19 25 25 25 13.805 0 25-11.193 25-25C45 6.192 33.805-5 20-5"/> <path d="M22.043 33.28h-5.49V20h-2.747v-4.578h2.748v-2.747c0-3.732 1.55-5.953 5.95-5.953h3.668v4.575H23.88c-1.712 0-1.83.637-1.83 1.837v2.29h4.146L25.708 20h-3.662v13.276l-.003.003z"/> </g> </svg>
				{ this.props.shouldShowName && <span className={styles.name}>Facebook</span> }
			</a>
		} else {
			return null
		}

	}

}

FacebookButton.defaultProps = {
	customClass: 'normal',
	onSelect: () => {},
	shouldShowName: true,
}

FacebookButton.propTypes = {
	dataObject: PropTypes.object,
	vendors: PropTypes.object,
	customClass: PropTypes.string,
	onSelect: PropTypes.func,
	shouldShowName: PropTypes.bool,
}

function mapStateToProps(state) {
	return { vendors: state.vendors }
}

export default connect(mapStateToProps)(FacebookButton)
